module.exports = __webpack_public_path__ + "static/10-yose-b6a6e11905a6bf321369d1e887cc467f.jpg";